import { useMutation } from 'react-query';

import { copyLogicCheckerConfigurationBetweenContracts as mutationFn } from 'api/endPoints/copyLogicCheckerConfigurationBetweenContracts';

export const useMutationCopyQualitySettings = () => {
    return useMutation<any, QueryError, ICopyQualitySettings>('copyQualitySettings', (params) => mutationFn(params));
};

export interface ICopyQualitySettings {
    fromContractId: number;
    toContractIds: number[];
}
